import { useQuery } from "@tanstack/react-query";
import { getUgcSection } from "../../api/apiUgc";

export const useGetUgcSection = () => {
    const { data, isLoading, error, refetch } = useQuery({
        queryKey: ["ugc-section"],
        queryFn: getUgcSection,
    });

    return {
        ugcSection: data?.data || {},
        isLoading,
        error,
        refetch,
    };
};
